import React from 'react'
import { LuSquare, LuSquareMinus } from 'react-icons/lu'

import { BulkUpdatePayload } from '@/redux/slices/referralsImportBase'

interface Props {
  hasSelected: boolean
  bulkUpdateItems: (payload: BulkUpdatePayload) => void
}

const SelectHeader: React.FC<Props> = ({ hasSelected, bulkUpdateItems }) => {
  return (
    <button
      className="text-body-base flex items-center justify-center border-0"
      style={{
        width: '40px',
        height: '45px',
        background: 'none',
        outline: 'none',
      }}
      onClick={() => {
        bulkUpdateItems({
          filter: {},
          data: { selected: !hasSelected },
        })
      }}
    >
      {hasSelected ? <LuSquareMinus /> : <LuSquare />}
    </button>
  )
}

export default SelectHeader
